// extracted by mini-css-extract-plugin
export default {"link":"PrintHeaderNavItem_link__JcUmX","active":"PrintHeaderNavItem_active__aUSOO"};